export default "__VITE_ASSET__CDiaPKhK__"